module.exports = __webpack_public_path__ + "img/wash_hair_splash.89aeee1d.jpg";